export const FILE_MESSAGE = {
  SIZE: " File size limit exceeds",
  ONE_FILE: "One File At a time",
  TYPE1: "Format should be png,jpg,jpeg,docx,pdf",
};

export const COMMON_MESSAGES = {
  CLAIM_INFO: (name, address, title) =>
    `Are you sure to ${title} business ${name} in ${address}`,
  ADDED: (type) => toTitleCase(type) + " has been added successfully",
  // UPDATED: (type)=> toTitleCase(type) + " has been updated successfully",
  BLOCKED: {
    title: `BLOCKED`,
    tip: `It will be blocked permanently!!`,
    confirm: (type) => `Do you want to block ${type.toLowerCase()}?`,
    success: (type) => `${toTitleCase(type)} has been blocked successfully`,
  },
  ACTIVE: {
    title: `ACTIVE`,
    confirm: (type) => `Do you want to active ${type.toLowerCase()}?`,
    success: (type) => `${toTitleCase(type)} has been active successfully`,
  },
  DELETED: {
    title: `DELETED`,
    confirm: (type) => `Do you want to delete ${type.toLowerCase()}?`,
    success: (type) => `${toTitleCase(type)} has been deleted successfully`,
  },
  COMPLETED: {
    title: `COMPLETED`,
    confirm: (type) => `Do you want to complete ${type.toLowerCase()}?`,
    success: (type) => `${toTitleCase(type)} has been completed successfully`,
  },
  PENDING: {
    title: `PENDING`,
    confirm: (type) => `Do you want to add ${type.toLowerCase()} in pending?`,
    success: (type) =>
      `${toTitleCase(type)} has been added to pending successfully`,
  },
};

export const SOMETHING_WENT_WRONG =
  "Something went wrong , Please try again later.";

export const SEARCH_MESSAGE = {
  SEARCH: `Search by`,
  NAME: `name`,
  EMAIL: `email`,
  NUMBER: `number`,
  DESCRIPTION: `description`,
  TITLE: `title`,
  MESSAGE: `message`,
  BUSINESS: `Business`,
};

export const toTitleCase = (str) => {
  return str.charAt(0).toUpperCase() +  str.slice(1);
};
